import React from 'react';
import { Box } from '@mui/material';

const embeddedViewerStyles = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: '#f5f5f5',
};

const ViewerDialogFrame = ({ embedded = false, DialogComponent, children, ...dialogProps }) => {
  if (embedded) {
    return <Box sx={embeddedViewerStyles}>{children}</Box>;
  }

  return <DialogComponent {...dialogProps}>{children}</DialogComponent>;
};

export default ViewerDialogFrame;
